import { render, staticRenderFns } from "./StripeRedirect.vue?vue&type=template&id=4e5b5a06&scoped=true"
import script from "./StripeRedirect.vue?vue&type=script&lang=js"
export * from "./StripeRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b5a06",
  null
  
)

export default component.exports